import * as React from 'react';
import { Alert, Box, Button, Checkbox, Grid, Input, Stack, Textarea } from "@mui/joy";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";
import { isNotNull } from "../../helper/functions";
import { generalErrorAction, publicarError } from "../../helper/general-error/GeneralErrorSlice";
import { atualizaCampoEmEndicao, atualizaStateCampo, definirNotaEmEdicao, notaVazia, salvarNota, triggerSalvarNota } from '../NotetakerSlice';
import { formatDateComHoras } from '../../helper/functions';
import { formatDateJavaComHoras } from '../../helper/functions';

function NotaEditor() {
    let { noteId } = useParams();

    var dispatch = useDispatch()
    var nota = useSelector((state) => state.notetaker.notaEmEdicao)
    var notas = useSelector((state) => state.notetaker.data)
    var podeSalvar = isNotNull(nota)
    var edicaoError = useSelector((state) => state.notetaker.edicaoError)
    var processando = useSelector((state) => state.notetaker.edicaoProcessando)
    var redirectAfter = useSelector((state) => state.notetaker.redirectAfter)

    var firstLoad = () => {

        var n = notaVazia()

        if (isNotNull(noteId)) {
            var filtradas = notas.filter(e => e.id == noteId)

            if (filtradas.length > 0) {
                n = filtradas[0]
                dispatch(definirNotaEmEdicao({ ...n }))
                return
            } else {
                dispatch(publicarError(generalErrorAction(
                    "NotaEditor.carregandoNota",
                    "--",
                    "--",
                    "Nota não encontrada"
                )))
            }
        }

        dispatch(definirNotaEmEdicao(notaVazia()))
    }

    var salvar = () => {
        dispatch(triggerSalvarNota({
            nota: nota,
            redirectAfter: false
        }))
    }


    var salvarEhFechar = () => {
        dispatch(triggerSalvarNota({
            nota: nota,
            redirectAfter: true
        }))
    }


    var updateCampo = (campo, value) => {
        dispatch(atualizaCampoEmEndicao({
            campo,
            value
        }))
    }

    var updateTags = (tag) => {
        var t = []

        nota.tags.forEach(e => t.push(e))

        if (t.includes(tag)) {
            t.splice(t.indexOf(tag), 1)
        } else {
            t.push(tag)
        }

        updateCampo("tags", t)
    }

    React.useEffect(() => {
        dispatch(atualizaStateCampo("redirectAfter", false))
        dispatch(definirNotaEmEdicao(null))
        firstLoad()
    }, []);

    var NotaCheckbox = (props) => {
        return <Checkbox
            label={props.label}
            value={props.value}
            checked={nota ? nota.tags.includes(props.value) : false} onClick={(e) => updateTags(e.target.value)}
            disabled={processando} />
    }

    if (redirectAfter) {
        return <Navigate to="/notetaker" />
    }

    return podeSalvar != true ? "Carregando..." : <Grid container>
        <Grid xs={12} sx={{ padding: "5px 10px" }}>
            {edicaoError != null && <Alert variant={"soft"} color="danger">
                {edicaoError}
            </Alert>}
        </Grid>
        <Grid xs={12} sx={{ padding: "5px 10px" }}>
            <Input
                type="text"
                placeholder="Titulo..."
                value={nota.titulo}
                disabled={processando}
                autoFocus
                onChange={(e) => updateCampo("titulo", e.target.value)} />
        </Grid>
        <Grid  sx={{ padding: "5px 10px" }}>
            ID: {nota.id} - {formatDateJavaComHoras(nota.dataCriacao)}
        </Grid>
        <Grid xs={12} sx={{ padding: "5px 10px" }}>
            <Stack direction={"row"} spacing={2}>
                <NotaCheckbox label="Concluída" value="CONCLUIDA" />
                <NotaCheckbox label="Prioridade" value="PRIORIDADE" />
                <NotaCheckbox label="Importante" value="IMPORTANTE" />
                <NotaCheckbox label="Revisar" value="REVISAR" />
            </Stack>
        </Grid>
        <Grid xs={12} sx={{ padding: "5px 10px" }}>
            <Textarea
                minRows={25}
                value={nota.conteudo}
                placeholder="Nota..."
                disabled={processando}
                onChange={(e) => updateCampo("conteudo", e.target.value)}></Textarea>
        </Grid>
        <Grid xs={12} sx={{ padding: "5px 10px", textAlign: "right" }}>
            {podeSalvar && <Stack direction={"row"} alignItems={"flex-end"} justifyContent={"flex-end"} spacing={1}>
                <Button onClick={salvarEhFechar} disabled={processando} color="danger">{processando ? "Salvando..." : "Salvar e fechar"}</Button>
                <Button onClick={salvar} disabled={processando}>{processando ? "Salvando..." : "Salvar"}</Button>
            </Stack>}
        </Grid>
    </Grid>
}

export default NotaEditor;